import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_CITIES = `${HOME_SERVICE}/cities`;

export const cities = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_CITIES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_CITIES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_CITIES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_CITIES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { ...data, modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_CITIES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
